import PropTypes from 'prop-types'
import React from 'react'

import List from 'components/List'
import { ResizeContext } from 'contexts/Resize'
import useInViewCommon from 'hooks/useInViewCommon'
import { BoxBase, Row } from 'styles/components/layout'
import { H1Small as H1 } from 'styles/components/typography'

import EarthMedia from './components/EarthMedia'
import EarthMobile from './components/EarthMobile'
import { EarthWrapper, ColContent } from './styles'

const SectionAncestry = ({ title, list }) => {
  const { mobile, breakpoint } = React.useContext(ResizeContext)
  const [ref, loadContent] = useInViewCommon()

  const Earth = React.useMemo(() => {
    if (!breakpoint || !loadContent) {
      return null
    }

    if (mobile) {
      return EarthMobile
    }

    return EarthMedia
  }, [breakpoint, mobile, loadContent])

  return React.useMemo(
    () => (
      <BoxBase
        ref={ref}
        bg="grass"
        color="white"
        position="relative"
        overflow="hidden"
      >
        <EarthWrapper>{Earth && <Earth {...{ loadContent }} />}</EarthWrapper>

        <Row>
          <ColContent
            width={{
              xs: 1,
              md: 1 / 2,
            }}
          >
            <article>
              <H1 as="h2" dangerouslySetInnerHTML={{ __html: title }} />
              <List textColor="white">
                {list.map((item, key) => (
                  <List.Item key={key} bulletColor="white">
                    {item}
                  </List.Item>
                ))}
              </List>
            </article>
          </ColContent>
        </Row>
      </BoxBase>
    ),
    [ref, loadContent, title, list, Earth],
  )
}

SectionAncestry.propTypes = {
  title: PropTypes.string,
  list: PropTypes.array,
}

export default SectionAncestry
